export default function IconSalesforce(props: { size?: number }) {
  const { size = 24 } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path
        fill="#00a1e0"
        d="M10 5.2a4.1 4.1 0 0 1 3.2 1.6 3.4 3.4 0 0 1 4.7 1.4 3.9 3.9 0 0 1 1.7 7.5 3.5 3.5 0 0 1-4.7 2.4 3.7 3.7 0 0 1-6.3.2 4 4 0 0 1-4.8-3.8 3.7 3.7 0 0 1 1.5-6.4A4.1 4.1 0 0 1 10 5.2z"
      />
    </svg>
  );
}
